import { Typography, styled } from '@mui/material';

export const PageTitle = styled(Typography)(({ theme }) => ({
  fontStyle: 'italic',
  fontSize: '2rem',
  fontWeight: 600,
  lineHeight: '2.0625rem',
  color: theme.palette.primary.main,
}));
